"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateTextInputSchema = void 0;
exports.default = DateTextInput;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
const date_fns_1 = require("date-fns");
const mask_1 = require("@react-input/mask");
exports.dateTextInputSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: zod_1.z
        .string()
        .refine((val) => !isNaN(new Date(val).getTime()), 'Date Of Birth should match format "Valid Date"')
        .transform((val) => new Date(val)),
    patientAge: zod_1.z
        .string()
        .refine((val) => !isNaN(new Date(val).getTime()), 'Date Of Birth should match format "Valid Date"')
        .refine((val) => {
        const yearsSinceDate = (0, date_fns_1.differenceInYears)(new Date(), new Date(val));
        return yearsSinceDate >= 1 && yearsSinceDate <= 150;
    }, 'Patient age must be 1-150 years old.')
        .transform((val) => new Date(val)),
    guarantorAge: zod_1.z
        .string()
        .refine((val) => !isNaN(new Date(val).getTime()), 'Date Of Birth should match format "Valid Date"')
        .refine((val) => {
        const yearsSinceDate = (0, date_fns_1.differenceInYears)(new Date(), new Date(val));
        return yearsSinceDate >= 18 && yearsSinceDate <= 150;
    }, 'Age must be 18-150.')
        .transform((val) => new Date(val)),
});
/**
 *
 * @NOTE
 *
 * This is being added for the sake of parity with a legacy app, not recommended for additional
 * use - hopefully will end up deprecating.  Reasoning:
 *
 * - accessibility/semantics
 * - issues typing/recognizing dates during entry
 * - edit after the fact is difficult
 *
 * @USAGE
 *
 * On submit this component will supply a date object on valid entry, but it must be provided
 * with a pre-formatted string for the date if you need a default value.  This is unavoidable
 * because of react-hook-form's stance on controlled inputs
 */
function DateTextInput({ name, label, required, autoComplete }) {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { field, formState: { errors }, } = (0, react_hook_form_1.useController)({ name, control });
    const error = errors[name];
    const [isFocused, setIsFocused] = (0, react_1.useState)(false);
    const [displayValue, setDisplayValue] = (0, react_1.useState)(field.value || '');
    // Mask instance
    const inputRef = (0, mask_1.useMask)({
        mask: 'MM/DD/YYYY',
        showMask: isFocused || !!displayValue, // Show mask only if focused or valid input is present
        separate: true,
        replacement: { D: /\d/, M: /\d/, Y: /\d/ },
    });
    // Sync field.value with internal state
    (0, react_1.useEffect)(() => {
        const value = field.value || ''; // Extract complex logic to a separate variable
        setDisplayValue(value);
    }, [field.value]); // Use `field.value` directly as a dependency
    // Handlers
    const handleFocus = () => setIsFocused(true);
    const handleBlur = () => {
        setIsFocused(false);
    };
    const handleChange = (event) => {
        const value = event.target.value;
        setDisplayValue(value);
        field.onChange(value);
        if (event.target.value === 'MM/DD/YYYY') {
            setDisplayValue('');
            field.onChange('');
        }
    };
    return ((0, jsx_runtime_1.jsx)(TextField_1.default, Object.assign({}, field, { value: displayValue, onChange: handleChange, inputRef: inputRef, autoComplete: autoComplete, required: required, placeholder: 'MM/DD/YYYY', fullWidth: true, label: label, error: Boolean(error), helperText: error === null || error === void 0 ? void 0 : error.message, onFocus: handleFocus, onBlur: handleBlur, type: "text", inputProps: {
            inputMode: 'numeric',
        } })));
}
//# sourceMappingURL=DateTextInput.js.map